// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { Pen, SolidBrush } from '@shared/commons/Graphics';
import { ActionType, ToolView } from './ToolView';
import { ThemeManager } from '@front/controls/misc/ThemeManager';
export class TextToolView extends ToolView {
    constructor(dataCacheTool, chartId) {
        super(dataCacheTool, chartId);
        this.textRect = Rectangle.Empty();
        this.editTextRect = Rectangle.Empty();
        this.wasCreated = false;
        this.textInput = null;
        this.isEditingEnded = false;
        this.excludedOuterActionTypes = [ActionType.DoubleClick];
    }
    Draw(gr, ww, param) {
        if (this.textInput)
            return;
        try {
            const screenPoints = this.screenPoints;
            const p0 = screenPoints[0];
            const x0 = p0[0];
            const y0 = p0[1];
            if (this.dataCacheTool == null) {
                return;
            }
            const textBrush = new SolidBrush(this.dataCacheTool.color);
            const textSize = gr.GetTextSize(this.dataCacheTool.text, this.dataCacheTool.font, false);
            const padding = 8;
            this.textRect = new Rectangle(x0, y0 - textSize.height, textSize.width + 2 * padding, TextToolView.HEIGHT);
            this.editTextRect = new Rectangle(this.textRect.X, this.textRect.Y, this.textRect.Width, this.textRect.Height);
            const borderPen = new Pen(ThemeManager.colors.chartTextToolBorder);
            gr.RoundRectangle(this.textRect, 4, null, borderPen);
            gr.DrawStringInRect(this.dataCacheTool.text, this.dataCacheTool.font, textBrush, this.textRect, false, 'center', 'middle');
            if (this.wasCreated) {
                this.initEditControl();
                this.wasCreated = false;
            }
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
    }
    IsSelectCheck(x, y) {
        if (this.textRect.Contains(x, y)) {
            return true;
        }
        return false;
    }
    initEditControl() {
        var _a, _b, _c, _d;
        if (this.textInput !== null || !isValidString(this.chartViewId)) {
            return;
        }
        const textRect = this.editTextRect;
        this.textInput = document.createElement('input');
        this.textInput.className = 'chart-text-tool';
        this.textInput.type = 'text';
        this.textInput.value = (_b = (_a = this.dataCacheTool) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
        this.textInput.style.left = `${textRect.X}px`;
        this.textInput.style.top = `${textRect.Y}px`;
        this.textInput.style.font = (_c = this.dataCacheTool) === null || _c === void 0 ? void 0 : _c.font;
        this.textInput.style.color = (_d = this.dataCacheTool) === null || _d === void 0 ? void 0 : _d.color;
        this.textInput.style.width = `${textRect.Width}px`;
        this.textInput.style.height = `${textRect.Height}px`;
        const chartElem = document.querySelector('#' + this.chartViewId);
        chartElem.parentElement.appendChild(this.textInput);
        this.textInput.focus();
        this.textInput.select();
        this.textInput.onblur = () => {
            this.endEditing();
        };
        this.textInput.onkeydown = (e) => {
            e.stopPropagation();
            this.handleKeyDown(e);
        };
    }
    handleKeyDown(event) {
        var _a, _b;
        if (event.key === 'Enter')
            this.endEditing();
        else if (event.key === 'Escape' && this.textInput) {
            this.textInput.value = (_b = (_a = this.dataCacheTool) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : '';
            this.endEditing();
        }
    }
    endEditing() {
        if (this.isEditingEnded || !this.textInput)
            return;
        this.isEditingEnded = true;
        this.dataCacheTool.text = this.textInput.value;
        if (this.textInput.parentElement) {
            this.textInput.remove();
        }
        this.textInput = null;
        this.FireUpdate();
        this.isEditingEnded = false;
    }
    ProcessDoubleClick(e) {
        this.initEditControl();
    }
    OnFinishCreationTool(e) {
        var _a;
        if (isNullOrUndefined(e)) {
            return;
        }
        const event = (_a = e._baseEvent.originalEvent) !== null && _a !== void 0 ? _a : e._baseEvent;
        const eventChartId = event.target.id;
        if (eventChartId === this.chartViewId) {
            this.wasCreated = true;
        }
        super.OnFinishCreationTool(e);
    }
}
TextToolView.HEIGHT = 20;
